import React from 'react';
import {
    useGetBudgetUserExerciceSettings,
    useMutateBudgetUserExerciceSetting,
} from './hooks';
import { useTranslation } from 'react-i18next';
import ToggleWithTooltip from 'ui/ToggleButton/ToggleWithTooltip';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';

type Props = {
    exercice: number;
    context: Record<string, string>;
};

const BudgetReportToggle = ({
    exercice,
    context,
}: Props): React.ReactElement | null => {
    const {
        budgetReportExerciceData: { isReportedAmountUsed },
        isLoading,
    } = useGetBudgetUserExerciceSettings(exercice);
    const { mutate } = useMutateBudgetUserExerciceSetting();
    const { t } = useTranslation();
    const title = t('budget.reportToggle.title');
    const tooltipTitle = t('budget.reportToggle.tooltip');
    if (isLoading) {
        return (
            <ToggleWithTooltip
                title={title}
                tooltipTitle={tooltipTitle}
                onChange={() => {}}
            />
        );
    }
    const onChange = () => {
        const newIsReportedAmountUsed = !isReportedAmountUsed;
        mutate({
            exercice,
            isReportedAmountUsed: newIsReportedAmountUsed,
        });
        trackEventBudget(TRACKABLE_EVENTS.budget.settings.toggleAddReported, {
            toggleState: newIsReportedAmountUsed ? 'ON' : 'OFF',
            ...context,
        });
    };
    return (
        <ToggleWithTooltip
            title={title}
            tooltipTitle={tooltipTitle}
            isChecked={isReportedAmountUsed}
            onChange={onChange}
        />
    );
};
// ts-prune-ignore-next
export default BudgetReportToggle;
